// It must we a one character string!
export const PERMISSIONS_DOMAIN_DELIMITER = '/';
export const DOMAIN_PREFIX = 'Zedoc/';

export const VISIBILITY_PRIVATE = 'private';
export const VISIBILITY_LIMITED = 'limited';
export const VISIBILITY_PUBLIC = 'public';
